<template>
  <button
    class='label-button'
    :class="[{
      'is-active': isActive,
      'is-disabled': isDisabled,
      'is-chevron-active': isChevronActive
    }]"
    @click='emit("click")'
  >
    <slot />
    <template v-if='isReset'>
      <div class='separator' />
      <ResetIcon @click='reset($event)' />
    </template>
    <ChevronIcon
      v-if='isChevron'
      class='chevron'
    />
  </button>
</template>

<script>
export default {
  name: 'LabelButton'
};
</script>

<script setup>
import ResetIcon from '@/../images/vue/components/label_button/reset.svg?inline';
import ChevronIcon from '@/../images/vue/components/label_button/chevron.svg?inline';

defineProps({
  isActive: { type: Boolean, required: true },
  isDisabled: { type: Boolean, required: false, default: false },
  isReset: { type: Boolean, required: false, default: false },
  isChevron: { type: Boolean, required: false, default: false },
  isChevronActive: { type: Boolean, required: false, default: false }
});
const emit = defineEmits(['click', 'reset']);

function reset(event) {
  event.stopImmediatePropagation();
  emit('reset');
}
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/responsive'
@import 'app/packs/stylesheets/mixins/typography'

.label-button
  +p3
  align-items: center
  background: var(--gray-100)
  border-radius: 100px
  border: 1px solid transparent
  display: flex
  letter-spacing: 0.16px
  transition: background var(--transition-duration), border-color var(--transition-duration)
  user-select: none
  white-space: nowrap

  +lte_ipad
    gap: rem4(8px)
    height: rem4(36px)
    padding: 0 rem4(12px)

  +gte_laptop
    gap: 8px
    height: 36px
    padding: 0 12px

  &:not(.is-disabled)
    cursor: pointer

    +gte_laptop
      &:hover
        background: var(--gray-200)

    &:active
      background: var(--gray-300)

    &.is-active
      background: rgba(255, 79, 0, 0.10)
      border-color: #ff4f00
      color: #ff4f00

      +gte_laptop
        &:hover
          background: rgba(255, 79, 0, 0.15)

      &:active
        background: rgba(255, 79, 0, 0.2)

  &.is-disabled
    background: var(--gray-100)
    color: var(--gray-400)

  svg.chevron
    transition: transform var(--transition-duration)

  &.is-chevron-active
    background: var(--gray-200)

    +gte_laptop
      &:hover
        background: var(--gray-300)

    &:active
      background: var(--gray-200)

    svg
      transform: rotate(180deg)

.separator
  border-left: 1px solid #ff4f00

  +lte_ipad
    height: rem4(19px)

  +gte_laptop
    height: 19px
</style>
